export const data = [
  {
    type: "editor",
    pos: {
      x: 0,
      y: 0,
    },
    id: "",
    data: {},
    format: {
      stroke: "",
      fill: "",
      radius: "",
    },
  },
  {
    type: "text",
    pos: {
      x: 0,
      y: 0,
    },
    id: "",
    data: {
      body: "Text changes",
    },
    format: {
      stroke: "",
      fill: "",
      fontFamily: "",
      alignment: "",
      textStyle: "",
    },
  },
  {
    type: "shape",
    pos: {
      x: 0,
      y: 0,
    },
    id: "",
    data: {
      x: 0,
      y: 0,
      stroke: "",
      fill: "",
      radius: 12,
      width: 12,
      height: 12,
      //for stars
      numPoints: 5,
      innerRadius: 20,
      outerRadius: 40,
    },
    format: {
      stroke: "",
      fill: "",
      radius: "",
      opacity: "",
    },
  },

  {
    type: "image",
    pos: {
      x: 0,
      y: 0,
    },
    id: "",
    data: {
      link:
        "https://images.unsplash.com/photo-1593642532973-d31b6557fa68?ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60",
    },
    format: {
      stroke: "",
      radius: "",
      opacity: "",
    },
  },
  {
   type: "canvas",
   id: "",
   format: {
     fill: "",
     background: "",
     template: ""
   }
  }
];
